import type { TOC } from '@ember/component/template-only'
import { ThStandard } from 'teacher-ui-client/components/th/standard'
import { t } from 'ember-intl'
import { formatValue } from 'teacher-ui-client/utils/format-value'
import type { StadiumOverviewReportData } from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/index/route'

interface Args {
  isLoading?: boolean
  overviewData: StadiumOverviewReportData['overview']
}

interface Signature {
  Args: Args
  Element: HTMLTableElement
}
export const StudentStadiumOverview: TOC<Signature> = <template>
  <table class="border-oceany-blue-150 border-b text-center" ...attributes>
    <thead class="bg-oceany-blue-50">
      <tr class="divide-x divide-white">
        <th></th>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.spelling"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.grammar"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.vocabulary"}}
        </ThStandard>
        <ThStandard>
          {{t "components.reporting.tables.readingEggspress.dashboardStudent.headers.usage"}}
        </ThStandard>
      </tr>
    </thead>
    <tbody class="divide-oceany-blue-150 divide-y {{if @isLoading 'opacity-50'}}">
      <tr>
        <th class="p-3 text-left font-normal">{{t
            "components.reporting.tables.readingEggspress.dashboardStudent.stadiumMetrics.eventsCompleted"
          }}</th>
        <td class="p-3">{{formatValue @overviewData.game_types.spelling.events_completed replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.game_types.grammar.events_completed replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.game_types.vocabulary.events_completed replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.game_types.usage.events_completed replacement="0"}}</td>
      </tr>
      <tr>
        <th class="p-3 text-left font-normal">{{t
            "components.reporting.tables.readingEggspress.dashboardStudent.stadiumMetrics.correctAnswers"
          }}</th>
        <td class="p-3">{{formatValue @overviewData.game_types.spelling.correct_answers replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.game_types.grammar.correct_answers replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.game_types.vocabulary.correct_answers replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.game_types.usage.correct_answers replacement="0"}}</td>
      </tr>
      <tr>
        <th class="p-3 text-left font-normal">{{t
            "components.reporting.tables.readingEggspress.dashboardStudent.stadiumMetrics.accuracyPercentage"
          }}</th>
        <td class="p-3">{{formatValue @overviewData.game_types.spelling.accuracy_percentage replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.game_types.grammar.accuracy_percentage replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.game_types.vocabulary.accuracy_percentage replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.game_types.usage.accuracy_percentage replacement="0"}}</td>
      </tr>
      <tr>
        <th class="p-3 text-left font-normal">{{t
            "components.reporting.tables.readingEggspress.dashboardStudent.stadiumMetrics.highestScore"
          }}</th>
        <td class="p-3">{{formatValue @overviewData.game_types.spelling.highest_score replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.game_types.grammar.highest_score replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.game_types.vocabulary.highest_score replacement="0"}}</td>
        <td class="p-3">{{formatValue @overviewData.game_types.usage.highest_score replacement="0"}}</td>
      </tr>
    </tbody>
  </table>
</template>

export default StudentStadiumOverview
